module.exports = __webpack_public_path__ + "img/Embers-Adrift-2022-004.77dd33a6.jpg";